// extracted by mini-css-extract-plugin
export default {"file-list":"_rngLp"};